import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { faGlasses, faLaptopHouse } from '@fortawesome/free-solid-svg-icons';
import { Regex } from 'src/app/core/constants/app.constant';

@Directive({
    selector: '[timeInput]',
    standalone: false
})
export class TimeInputDirective {

  constructor(private el: ElementRef) { }

  @Output() isValid = new EventEmitter<any>();


  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    let dateVal = this.el.nativeElement.value;
    if (dateVal.length === 2) {
      if (event.code != 'Backspace') {
        this.el.nativeElement.value = dateVal + ':';
      }
      this.isValid.emit(false);
    }
    if (dateVal.length === 5 && dateVal.match(Regex.Time)) {
      this.isValid.emit(true);
    } else {
      this.isValid.emit(false);
    }
  }
}
